var caseStudies = {
  selectors: {
    base: '.js-block-case-studies',
    listing: '.js-block-case-studies-listing',
    group: '.js-block-case-studies-group',
    item: '.js-block-case-studies-item',
    load_more: '.js-block-case-studies-load-more',
    button: '.js-block-case-studies-load-more-button',
  },

  init: function () {
    this.bindEvents();
  },

  bindEvents: function () {
    const self = this;
    const base = document.querySelector(self.selectors.base);
    if (!base) return;

    base.addEventListener('click', function (e) {
      const btn = e.target.closest(self.selectors.button);
      if (!btn) return;
      e.preventDefault();

      const listing = document.querySelector(self.selectors.listing);
      if (!listing) return;

      const hiddenGroups = listing.querySelectorAll(self.selectors.group + '.hidden');
      const items = listing.querySelectorAll(self.selectors.item);

      if (hiddenGroups.length > 0) {
        hiddenGroups[0].classList.remove('hidden');
      }

      const stillHidden = listing.querySelectorAll(self.selectors.group + '.hidden');
      if (stillHidden.length === 0) {
        const loadMore = document.querySelector(self.selectors.load_more);
        if (loadMore) loadMore.classList.add('hidden');
      } else {
        const visibleGroups = listing.querySelectorAll(self.selectors.group + ':not(.hidden)');
        const span = btn.querySelector('span');
        if (span) {
          span.textContent = `(${Math.min(items.length - (visibleGroups.length * 6), 6)})`;
        }
      }
    });
  }
};

export { caseStudies };